// Core
import { useState } from 'react';
import { useQuery } from 'react-query';
import { Box, Button, Grid, Skeleton, useColorMode } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';
import { validateLoadMore } from 'services/Utils';

// Components
import Giveaways from './Giveaway';
import EmptyList from './EmptyList';

const Upcoming = ({ userData }) => {
    const limit = 9;
    const [offset, setOffset] = useState(0);
    const [data, setData] = useState([]);
    const [dataMeta, setDataMeta] = useState(); 
    const [errorMessage, setErrorMessage] = useState();

    const { colorMode } = useColorMode();
    const isDark = colorMode === 'dark';

    const { isLoading } = useQuery({
        queryKey: ['upcoming', offset],
        queryFn: async () => {
            const response = await apiService.getGiveaways({ limit, offset, status: 'active' });

            if(response.statusCode === 400){
                setErrorMessage(response.message);
                return true;
            } else {
                setErrorMessage();
            }
            
            if(offset === 0){
                setData(response.data);
            } else {
                setData([...data, ...response.data]);
            }
            setDataMeta(response.meta);
            return true;
        },
        refetchOnWindowFocus: false,
        retry: false
    });

    const loadMore = async () => {
        setOffset(offset + limit);
    };

    return (
    	<>
        { isLoading && data.length === 0 ? ( 
            <Grid mt={{base: '24px', md: '40px'}} templateColumns={{ base: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }} gap="24px" templateRows='1fr'>
                <Skeleton borderRadius="16px" h="200px" />
                <Skeleton borderRadius="16px" h="200px" />
                <Skeleton borderRadius="16px" h="200px" />
            </Grid>
        ) : !isLoading && data.length === 0 ? 
            (
                <EmptyList 
                    title="No giveaways winners"
                    descriptions={ errorMessage ? errorMessage : 'There are no Giveaways upcoming here yet. Wait for Giveaways to be added.'}
                    />
        ) : (
            <>
    	        <Grid mt={{base: '24px', md: '40px'}} templateColumns={{ base: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }} gap="24px" templateRows='1fr'>
    			    { data?.map((item, index) => (
    			        <Giveaways key={index} item={item} type="upcoming" userData={userData} />
    			    ))}	
    	        </Grid>

                { validateLoadMore(data, dataMeta) && (
                    <Button 
                        isLoading={isLoading}  
                        variant={ isDark ? 'button-md-g' : 'button-md' } 
                        maxW="220px" 
                        onClick={loadMore} 
                        left="50%"
                        transform="translate(-50%, 0)"
                        m="24px auto">
                      Load More
                    </Button>
                )}
            </>
	    )}
	    </>
    );
};


export default Upcoming;